import { useState } from 'react'
import { listDeletedDrawings, restoreDrawing, type SavedDrawing } from '../lib/storage'

export default function Trash({ onRestore }: { onRestore: () => Promise<void> }) {
  const [items, setItems] = useState<SavedDrawing[] | null>(null)
  const [error, setError] = useState('')
  const refresh = async () => {
    try { setItems(await listDeletedDrawings()); setError('') }
    catch { setError('Could not load deleted boards. Try again.') }
  }
  return <section className="trash-panel"><button className="text-action" onClick={refresh}>Recently deleted boards</button>{error && <p role="alert">{error}</p>}{items && <><h2>Deleted boards</h2><p>Boards stay here until restored. Site data must remain on this device.</p>{!items.length && <p>No deleted boards.</p>}{items.map(item => <div key={item.id}><span>{item.title}</span><button onClick={async () => { try { await restoreDrawing(item.id); await refresh(); await onRestore() } catch { setError('Restore failed. Try again.') } }}>Restore</button></div>)}</>}</section>
}
